import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/goods/shoucang-active.png'
import _imports_1 from '@/assets/image/goods/shoucang.png'


const _withScopeId = n => (_pushScopeId("data-v-0c8891b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ShopHeader-msg" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = {
  key: 0,
  class: "ShopHeader-logo",
  src: "https://static-s.theckb.com/BusinessMarket/Client/market/market_wsy_logo.svg",
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  class: "ShopHeader-logo",
  src: "https://static-s.theckb.com/BusinessMarket/Client/market/market_skw_logo.svg",
  alt: ""
}
const _hoisted_5 = {
  key: 2,
  class: "ShopHeader-crown"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-right":"5px"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/market/market_crown_icon.svg",
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "ShopHeader-msg-cate" }
const _hoisted_8 = {
  key: 0,
  referrerPolicy: "no-referrer",
  class: "wrap",
  src: _imports_0
}
const _hoisted_9 = {
  key: 1,
  referrerPolicy: "no-referrer",
  class: "wrap",
  src: _imports_1,
  title: "收藏店铺"
}


import { useRoute, useRouter } from 'vue-router'
import { shopFavorite, shopFavoriteCancel } from '@/apis/shop'
import { ElMessage as message } from 'element-plus'
import { isD2C, isEN } from '@/store'
import { t } from '@/plugins/i18n'
import { addWWWtoURL } from '@/plugins/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  // 店铺详情
  shopDetail: {
    type: Object,
    default: null
  }
},
  setup(__props) {

const props = __props
const route = useRoute()
const router = useRouter()



// 收藏操作
const handleFavorite = () => {
  const formData = {
    shopCode: props.shopDetail.shopCode
  }
  if (props.shopDetail.favoriteFlag) {
    // 取消收藏
    shopFavoriteCancel(formData).then(res => {
      if (res.code === '0') {
        props.shopDetail.favoriteFlag = 0
      }
    })
  } else {
    // 添加收藏
    shopFavorite(formData).then(res => {
      if (res.code === '0') {
        props.shopDetail.favoriteFlag = 1
        message.success(t('店铺收藏成功'))
      }
    })
  }
}

// 跳转外链
const toLink = () => {
  if (isEN() && (props.shopDetail.platformType === 'WS' || props.shopDetail.platformType === 'VC')) {
    return
  }
  const url = addWWWtoURL(props.shopDetail.shopUrl)
  url && window.open(url)
}


return (_ctx: any,_cache: any) => {
  return (props.shopDetail)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["ShopHeader", _unref(isD2C)() ? 'd2c' : 'b2b'])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (__props.shopDetail.platformType === 'WS')
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : _createCommentVNode("", true),
            (__props.shopDetail.platformType === 'VC')
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["ShopHeader-msg-name", __props.shopDetail.channel === 2 ? 'hover' : '']),
              style: _normalizeStyle({ cursor: _unref(isEN)() ? '' : 'pointer' }),
              onClick: toLink
            }, _toDisplayString(__props.shopDetail.shopName ? __props.shopDetail.shopName : ' - '), 7),
            (__props.shopDetail.strongSupplier === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_unref(t)('实力档口')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_unref(t)('主营类目')) + "： ", 1),
            (__props.shopDetail.shopMajorCateName)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.shopDetail.shopMajorCateName.split('/'), (i) => {
                  return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(i), 1))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", {
          class: "ShopHeader-collect",
          onClick: handleFavorite
        }, [
          (__props.shopDetail.favoriteFlag === 1)
            ? (_openBlock(), _createElementBlock("img", _hoisted_8))
            : (_openBlock(), _createElementBlock("img", _hoisted_9))
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})